export default __webpack_public_path__ + "static/media/macos.5835fd1b.svg";